<template>
    <router-view />
</template>

<script>
export default { }
</script>



// WEBPACK FOOTER //
// src/pages/DrawingLayout.vue